// extracted by mini-css-extract-plugin
module.exports = {"container":"Flexbox_container__3h6ZQ"};